<template>
  <div>
    <div class="title">Claim Airdrop</div>
    <div class="des">
      <b>Ineligible wallet!</b> This wallet is not eligible for <br> Airdrop.
      <span @click="init">Switch account Check airdrop eligibility.</span>
    </div>
    <div class="errimg">
      <img src="../assets/images/error.png" alt="" srcset="">
      <p>Ineligible wallet!</p>
    </div>
    <div class="page_b">
      If you have any questions, please email us at <b>contact@treasurenet.org</b>
    </div>
  </div>
</template>

<script>
import { localSet } from '../utils/index'
export default {
  methods: {
    init() {
      localSet('zh', '')
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.title{
  margin-top: 0.96rem;
  font-size: 0.44rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #1F1F1F;
  line-height: 0.58rem;
}
.des{
  font-size: 0.24rem;
  font-family: DMSans-Regular, DMSans;
  font-weight: 400;
  color: #4C4C4C;
  line-height: 0.32rem;
}
.des span{
  color: #305CE2;
  cursor: pointer;
}

.errimg {
  padding-left: 1.09rem;
  margin-top: 0.64rem;
  margin-bottom: 0.84rem;
  width: 2.4rem;
  text-align: center;
}
.errimg img {
  width: 0.92rem;
}
.errimg p {
  font-size: 0.16rem;
  font-family: DMSans-Regular, DMSans;
  font-weight: 400;
  color: #FF8A1B;
  line-height: 0.3rem;
}

.page_b{
  font-size: 0.18rem;
  font-family: DMSans-Regular, DMSans;
  font-weight: 400;
  color: #4C4C4C;
  line-height: 0.24rem;
}

</style>
